import React from 'react';
import { Link } from 'react-router-dom';
import { Pin } from 'lucide-react';

export const ProductCard = ({ brandId, product, subtitle }) => (
  <Link
    to={`/brand/${brandId}/products/${product.slug}`}
    className="group relative block"
    data-testid={`product-card-${product.slug}`}
  >
    {product.pinned && (
      <span className="absolute top-2 right-2 z-10 bg-amber-400 text-white rounded-full p-1" title="Pinned">
        <Pin className="h-3 w-3" />
      </span>
    )}
    <div className="aspect-square bg-gray-50 rounded-lg overflow-hidden mb-3">
      {product.mainImage && (
        <img
          src={product.mainImage}
          alt={product.title || product.name}
          className="w-full h-full object-contain mix-blend-multiply transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
      )}
    </div>
    <p className="text-[11px] uppercase tracking-widest text-gray-400">{subtitle ?? product.productType}</p>
    <p className="text-sm font-medium text-gray-900 group-hover:text-gray-600 transition-colors truncate">{product.name}</p>
    <p className="text-xs text-gray-500 font-mono">
      {product.code}
      {product.variants?.length > 1 ? ` · ${product.variants.length} variants` : ''}
    </p>
  </Link>
);

export const ProductGrid = ({ brandId, products, subtitleFn }) => (
  <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-x-4 gap-y-8" data-testid="product-grid">
    {products.map((p) => (
      <ProductCard key={p.slug} brandId={brandId} product={p} subtitle={subtitleFn?.(p)} />
    ))}
  </div>
);
